interface Props {
  kicker: string;
  title: string;
  desc?: string;
  dark?: boolean;
}

export default function SectionHeader({ kicker, title, desc, dark = false }: Props) {
  return (
    <div className="mx-auto mb-10 max-w-2xl text-center md:mb-12">
      <span
        className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-sm font-bold ${
          dark ? 'bg-primary-500/20 text-primary-300' : 'bg-accent-100 text-accent-800'
        }`}
      >
        {kicker}
      </span>
      <h2 className={`mt-4 font-heading text-3xl sm:text-4xl ${dark ? 'text-background-50' : 'text-foreground-950'}`}>{title}</h2>
      {desc && <p className={`mt-4 text-base leading-relaxed ${dark ? 'text-background-200/80' : 'text-foreground-600'}`}>{desc}</p>}
    </div>
  );
}